import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Agendamento } from "../../../../services/Agendamento";
import { IAgendamentoCadastroForm } from "../../../../types/agendamento";

export const useCadastrarAgendamento = () => {
  return useMutation({
    mutationFn: (data: IAgendamentoCadastroForm) => Agendamento.postV2(data),
    onError: ({
      response: {
        data: { mensagem },
      },
    }: any) => {
      toast.error(mensagem);
    },
  });
};
